import {
  PUBLISHCONTAINER_DIALOG_OPEN,
  PUBLISHCONTAINER_DIALOG_CLOSE
} from "types/actions/publish-container-dialog"

const publishContainerDialogInitialState = {
  open: false,
  data: {}
}

export default (state = publishContainerDialogInitialState, action) => {
  switch (action.type) {
    case PUBLISHCONTAINER_DIALOG_OPEN:
    case PUBLISHCONTAINER_DIALOG_CLOSE:
      return {
        ...state,
        open: action.open,
        data: action.data ? action.data : {}
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/publish-container-dialog.js